<template>
  <ValidationProvider name="to" slim vid="to">
    <template #default="{ errors }">
      <BaseFormGroup>
        <VSelect
          v-model="modelValue"
          :options="options"
          placeholder="Select recipients"
          :disabled="disabled"
          class="vue-select"
        />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
